import script from "./FotoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FotoView.vue?vue&type=script&setup=true&lang=ts"

import "./FotoView.vue?vue&type=style&index=0&id=240bb4bf&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-240bb4bf"]])

export default __exports__